import { useRouter } from 'next/router'

import { useServiceScheduleContext } from '../../../context/serviceScheduleContext'
import { SERVICE_PACKAGE_STEPS } from '../../../utils/schedulingConstants'
import { featureFlags } from '../../../utils/constants'
import useFormStepCommon from './useFormStepCommon'

const usePackageFormStep = ({ finalStep, context }) => {
  const { state, functions, editSteps } = useServiceScheduleContext()
  const {
    review,
    isHowToPay
  } = state

  const {
    handlePackagePurchase
  } = functions

  const router = useRouter()

  const {
    activeStep,
    numberOfSteps,
    currentStep,
    nextDisabled,
    nextHidden,
    steps,
    backButtonProps,
    nextButtonProps,
    onUpdateScheduling,
    onGoTo,
    redirectToServices
  } = useFormStepCommon({ context })

  const calcPrevStep = (step = SERVICE_PACKAGE_STEPS.PET_AND_SERVICE) => {
    const redirectedStep = steps.find(packageStep => packageStep.step === step)

    onUpdateScheduling({
      ...editSteps()[redirectedStep.id]
    })
    onGoTo(redirectedStep.path)
  }

  const handleNextButtonClick = async () => {
    const remainingSteps = steps.filter((step) =>
      step.step > activeStep &&
      !step.active
    ).sort((a, b) => a.step - b.step)

    if (activeStep === SERVICE_PACKAGE_STEPS.PROFESSIONAL || !remainingSteps.length) {
      onUpdateScheduling({ activeStep: SERVICE_PACKAGE_STEPS.PROFESSIONAL })
      if (!featureFlags.enablePackagePurchase) {
        return
      }
      handlePackagePurchase({ context, router })
      return
    }

    onUpdateScheduling({
      activeStep: remainingSteps[0]?.step
    })

    onGoTo(remainingSteps[0]?.path)
  }

  const handleClickBackButton = async () => {
    if (activeStep === SERVICE_PACKAGE_STEPS.PET_AND_SERVICE) {
      await redirectToServices()
    } else {
      calcPrevStep(activeStep - 1)
    }
  }

  return {
    activeStep,
    numberOfSteps,
    currentStep,
    nextDisabled,
    nextHidden,
    review,
    isHowToPay,
    finalStep,
    steps,
    backButtonProps,
    scheduleForMoreOnePetProps: {},
    nextButtonProps,
    confirmScheduleProps: {},
    handleClickBackButton,
    handleNextButtonClick,
    handleScheduleForMoreOnePet: () => {}
  }
}

export default usePackageFormStep
